import React, { Component } from 'react';
// import Collapse from '../collapse/components/MinimalCollapse';
// import DropZone from '../form_dropzone/components/DropFiles';
import { Field, reduxForm } from 'redux-form';
import renderSelectField from '../Select';
import Moment from 'moment';
// import ComingSoon from '../coming-soon';
import { connect } from 'react-redux';
import EditIcon from 'mdi-react/SquareEditOutlineIcon';
import { loadCompliance } from '../../redux/actions/complianceActions';

const options = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' },
  { value: 3, label: 'Not Applicable' }
]

class RenderRow extends Component {
  state = {
    expanded: false,
    assignee: null,
    status: null,
    dueDate: null,
    controls: null,
    open: false
  }

  componentDidMount () {
    const { state } = this.props.control;
    return state ?
      this.setState({
        assignee: state.assignee,
        status: state.status,
        dueDate: state.dueDate
      }) : this.setState({ assignee: 1, dueDate: Moment(), status: this.props.defaultValue });
  }

  render () {
    const { control } = this.props;

    return (
      <tr className="control-row">
        <td>
          {control.question}
        </td>
        <td>
          <div className='form__form-group'>
            <div className='form__form-group-field'>
              <Field
                name='select'
                className='compliance-select-field'
                component={renderSelectField}
                options={options}
                defaultValue={options[2]}
                clearable={false}
              />
            </div>
          </div>
        </td>
        <td>
          <div className='form__form-group-icon'>
            <button className='uploadEvidence'><EditIcon color='#AEAEB0' /></button>
          </div>
        </td>
      </tr >
    )
  }
}


function mapStateToProps (state) {
  return {
    theme: state.theme,
    activities: state.profileActivity.activities
  }
}

export default connect(mapStateToProps, { loadCompliance })(reduxForm({
  form: 'render-row'
})(RenderRow))



// WEBPACK FOOTER //
// ./src/components/vendor_assessments/renderRowQuestionnaire.js